module.exports = __webpack_public_path__ + "assets/e5bd2377b2ca03a1d6538395558188a0.png";